import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import { ELEVATION } from '@openx/components-core/lib/theme/elevation';

export const DealPromptTileSkeleton = () => {
  return (
    <Grid sx={{ display: 'flex', maxWidth: '360px', width: '100%', position: 'relative' }}>
      <Card
        role="region"
        sx={{
          boxShadow: ELEVATION.elevation0,
          height: '100%',
          borderRadius: '4px',
          width: '100%',
        }}
        data-test="deal-prompt-tile-skeleton"
      >
        <CardContent
          sx={{ width: '100%', p: 0, paddingBottom: '16px !important', display: 'flex', flexDirection: 'column' }}
        >
          <Box sx={{ width: '100%', height: '78px', p: 2, pb: 1 }} data-test="skeleton-header">
            <Skeleton variant="rectangular" sx={{ p: 2, pb: 1, width: '100%', height: '100%' }} />
          </Box>

          <Divider />

          <Box sx={{ pt: 2, pb: 1, width: '92%', alignSelf: 'center' }} data-test="skeleton-leading-stats">
            <Skeleton variant="rectangular" sx={{ width: '100%', height: '48px' }} />
          </Box>

          <Divider sx={{ width: '92%', alignSelf: 'center' }} />

          <Box sx={{ pt: 1, pb: 1, width: '92%', alignSelf: 'center' }} data-test="skeleton-stats">
            <Skeleton variant="rectangular" sx={{ width: '100%', height: '80px' }} />
          </Box>

          <Divider sx={{ width: '92%', alignSelf: 'center' }} />

          <Box
            sx={{
              pt: 2,
              pb: 1,
              width: '100%',
              alignSelf: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
            data-test="skeleton-button"
          >
            <Skeleton variant="rectangular" sx={{ width: '100px', height: '32px' }} />
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};
